import "antd/es/date-picker/style";
import _DatePicker from "antd/es/date-picker";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classNames from 'classnames';
import hoistNonReactStatics from 'hoist-non-react-statics';
import './index.less';
var clsPrefix = 'osui-picker';

function attachOSUIClassName(Component) {
  var ComponentOut = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(Component, _objectSpread(_objectSpread({
      ref: ref
    }, props), {}, {
      className: classNames(clsPrefix, props.className),
      dropdownClassName: classNames("".concat(clsPrefix, "-dropdown"), props.dropdownClassName)
    }));
  });
  return ComponentOut;
}

var DatePicker = attachOSUIClassName(_DatePicker); // 确保所有的NonReactStatics都提升上来

hoistNonReactStatics(DatePicker, _DatePicker); // 覆盖

DatePicker.MonthPicker = attachOSUIClassName(_DatePicker.MonthPicker);
DatePicker.WeekPicker = attachOSUIClassName(_DatePicker.WeekPicker);
DatePicker.QuarterPicker = attachOSUIClassName(_DatePicker.QuarterPicker);
DatePicker.YearPicker = attachOSUIClassName(_DatePicker.YearPicker);
DatePicker.TimePicker = attachOSUIClassName(_DatePicker.TimePicker);
DatePicker.RangePicker = attachOSUIClassName(_DatePicker.RangePicker);
export default DatePicker;
//# sourceMappingURL=index.js.map